<div class="flex flex-col h-full justify-between">
  <div>
    <p class="font-['Roboto'] font-bold text-xl/6 text-[#333333] tracking-2percent">{{ labels.stellar.signIn.bankAccount.chooseBankAccount }}</p>
    <div
      *ngIf="optionConfig && optionConfig.length > 0"
      class="mt-8"
    >
      <app-custom-radio-input
        [labels]="labels"
        [selectedOptionId]="selectedBankAccount?.targetAccountProfileId ?? ''"
        [optionConfig]="optionConfig"
        (optionSelectEvent)="emitChangeSelectedBank($event)"
      ></app-custom-radio-input>
    </div>
    <button
      *ngIf="optionConfig && optionConfig.length < 2"
      (click)="emitBankModeChange('add')"
      class="flex items-center mt-4 bg-[#f2f2f2] border-none rounded-lg w-full"
    >
      <div>
        <img
          src="assets/images/add-new-plus-icon.svg"
          alt="plus in circle icon"
          class="size-6 m-[10px] mx-4 self-center"
        />
      </div>
      <p class="font-['Roboto'] text-sm">{{ labels.stellar.signIn.bankAccount.addNew }}</p>
    </button>
  </div>
  <div class="self-end w-full flex justify-start max-[430px]:justify-center items-center max-[430px]:pb-[30px] pb-12">
    <button
      type="button"
      [class]="
        !selectedBankAccount
          ? 'max-[430px]:continue-btn-disabled-mobile-outline continue-btn-disabled-desktop-outline'
          : 'max-[430px]:continue-btn-enabled-mobile-filled continue-btn-enabled-desktop-filled'
      "
      [disabled]="!selectedBankAccount"
      (click)="onContinue()"
    >
      <span
        [class]="!selectedBankAccount ? 'text-[#B3B3B3]' : 'text-[#FFFFFF]'"
        class="font-medium leading-6 tracking-3percen text-center transition-all"
      >
        {{ labels.stellar.signIn.continue }}
      </span>
    </button>
  </div>
</div>
